/* app/views/search-form.js
Bento Box App Search Form View
*/

import $ from 'jquery';
import _ from 'underscore';
import EventChannel from '../events.js';
import * as Config from '../config.js';
import * as Utils from '../utils.js';
import searchTemplate from '../../templates/search.html';
import navbarTemplate from '../../templates/navbar.html';
import { BaseView, ContainerView } from './base.js';


const Search = BaseView.extend({
  template: _.template(searchTemplate),
  selectors: {
    'searchInput': '#search-form input',
    'didYouMean': '.didYouMean',
    'didYouMeanTerm': '.didYouMean .term', 
  },
  events: {
    'submit #search-form': 'submitSearch',
  },
  
  initialize: function(options) {
    this.listenTo(
      EventChannel,
      'bento-box-collection-success:articles',
      this.renderDidYouMean
    );
  },

  render: function(vars) {
    let container = $(this.template(vars));
    this.$el.empty().append(container);
    return this;
  },

  submitSearch: function(ev) {
    ev.preventDefault();
    EventChannel.trigger('searchform:search', this.getFormVars());
  },
  
  getFormVars: function() {
    return {q: this.$el.find(this.selectors.searchInput).val()};
  },

  renderDidYouMean: function(vars) {
    let articlesColl = Config.boxes.articles.collection;
    if (articlesColl.didYouMean !== null) {
      EventChannel.trigger('spelling-suggestion-rendered', {q: vars.qDisplay});
      let term = articlesColl.didYouMean[0];
      this.$el.find(this.selectors.didYouMeanTerm).html(
        `<a class="text-warning" href="?q=${encodeURIComponent(term)}">${term}</a>`
      );
      this.$el.find(this.selectors.didYouMean).removeClass('d-none');
    }
  },
});

const Nav = BaseView.extend({
  template: _.template(navbarTemplate),

  render: function(vars) {
    let container = $(this.template(vars));
    this.$el.empty().append(container);
    return this;
  },
});


export {
  Nav,
  Search,
};
